'use client';

import { CredentialTypeFlag } from '#/components/ethereum/credential-type';
import { Button } from '#/components/ui/button';
import { Dialog, DialogTrigger } from '#/components/ui/dialog';
import { isDevelopment, isPreview } from '#/constants/env';
import { CredentialType as CredentialType_ } from '#/constants/pectra/credential-type';
import { useConfiguredChain } from '#/data/wagmi/configured';
import { cn } from '#/lib/utils';
import { StakingDialogContent } from '#/modules/dialogs/staking-dialog';
import { StakingDialogContentLegacy } from '#/modules/dialogs/staking-dialog-legacy';
import { Translation } from 'intl-lib';
import { PackagePlus } from 'lucide-react';
import { ComponentProps } from 'react';

export function CreateEthereumStakingButton({
  className,
  ...props
}: ComponentProps<'div'>) {
  const chain = useConfiguredChain();
  return (
    <div className={cn('flex items-center gap-2', className)} {...props}>
      <Dialog>
        <DialogTrigger asChild>
          <Button variant="primary">
            <PackagePlus className="h-4 w-4" />
            <Translation path="my_staking.staking_dialog.trigger" />
          </Button>
        </DialogTrigger>
        <StakingDialogContent />
      </Dialog>
      {(isDevelopment || isPreview) && chain.testnet && (
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="outline">
              <Translation path="my_staking.staking_dialog.trigger" />
              <CredentialTypeFlag credentialType={CredentialType_.TYPE1} />
            </Button>
          </DialogTrigger>
          <StakingDialogContentLegacy />
        </Dialog>
      )}
    </div>
  );
}
